export const actionTypes = {
  CLEAR_HIGHLIGHT: 'CLEAR_HIGHLIGHT',
  SET_NEXT_HIGHLIGHTED_INDEX: 'SET_NEXT_HIGHLIGHTED_INDEX',
  SET_PREVIOUS_HIGHLIGHTED_INDEX: 'SET_PREVIOUS_HIGHLIGHTED_INDEX',
  SET_HIGHLIGHTED_OPTION: 'SET_HIGHLIGHTED_OPTION',
  SET_HOLDING_SHIFT: 'SET_HOLDING_SHIFT',
  SET_SEARCH: 'SET_SEARCH',
  SET_OPTIONS: 'SET_OPTIONS',
  UNSET_HOLDING_SHIFT: 'UNSET_HOLDING_SHIFT',
}

export const reducer = (state, action) => {
  const payload = action.data
  switch (action.type) {
    case actionTypes.CLEAR_HIGHLIGHT:
      return {
        ...state,
        highlightedIndex: null,
        highlightedOption: null,
      }
    case actionTypes.SET_NEXT_HIGHLIGHTED_INDEX: {
      const hasNoHighlight = state.highlightedIndex === null
      let highlightedIndex
      let highlightedOption

      if (hasNoHighlight) {
        highlightedIndex = 0
        highlightedOption = state.options[0]
        return {
          ...state,
          highlightedIndex,
          highlightedOption,
        }
      }

      highlightedIndex =
        state.highlightedIndex < state.options.length - 1
          ? state.highlightedIndex + 1
          : 0
      highlightedOption =
        state.highlightedIndex < state.options.length - 1
          ? state.options[state.highlightedIndex + 1]
          : state.options[0]

      return {
        ...state,
        highlightedIndex,
        highlightedOption,
      }
    }
    case actionTypes.SET_PREVIOUS_HIGHLIGHTED_INDEX: {
      const hasNoHighlight = state.highlightedIndex === null
      let highlightedIndex
      let highlightedOption

      if (hasNoHighlight) {
        const index = state.options.length - 1
        highlightedIndex = index
        highlightedOption = state.options[index]
        return {
          ...state,
          highlightedIndex,
          highlightedOption,
        }
      }

      highlightedIndex =
        state.highlightedIndex > 0
          ? state.highlightedIndex - 1
          : state.options.length - 1
      highlightedOption =
        state.highlightedIndex > 0
          ? state.options[state.highlightedIndex - 1]
          : state.options[state.options.length - 1]

      return {
        ...state,
        highlightedIndex,
        highlightedOption,
      }
    }
    case actionTypes.SET_HIGHLIGHTED_OPTION:
      return {
        ...state,
        highlightedOption: payload,
      }
    case actionTypes.SET_HOLDING_SHIFT:
      return {
        ...state,
        holdingShift: true,
      }
    case actionTypes.SET_SEARCH:
      return {
        ...state,
        searchTerm: payload.searchTerm,
        highlightedIndex: null,
        highlightedOption: null,
        options: payload.options,
      }
    case actionTypes.SET_OPTIONS:
      return {
        ...state,
        ...payload,
      }
    case actionTypes.UNSET_HOLDING_SHIFT:
      return {
        ...state,
        holdingShift: false,
      }
    default:
      return state
  }
}
